import { MealyModelType } from '../mealyModelType';
import GaragentorSystem from './GaragentorSystem.svelte';
export const mealyModelGaragentor = {
    component: GaragentorSystem,
    type: MealyModelType.GARAGENTOR,
    // alphabet: ['hoch', 'runter', 'stop', 'Schalter_oben', 'Schalter_unten'],
    alphabet: ['Taster', 'Endschalter_oben', 'Endschalter_unten'],
    outputs: ['hoch', 'runter', 'stop'],
};
